/* ============================================================
   BEAUTY ICON STL — THEME JS (T05: Sticky header, nav, mobile)
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Smart Sticky Header ────────────────────────────────────
  const header = document.querySelector('.site-header');
  const announcementBar = document.getElementById('announcement-bar');
  let lastScrollY = 0;
  let ticking = false;
  const scrollThreshold = 60;

  function onScroll() {
    const currentY = window.scrollY;

    if (header) {
      // Add shadow on scroll — header stays visible always (sticky)
      header.classList.toggle('scrolled', currentY > 10);
      header.classList.remove('is-hidden');
    }

    // Hide announcement bar on scroll
    if (announcementBar && !announcementBar.classList.contains('is-dismissed')) {
      announcementBar.classList.toggle('is-hidden', currentY > 100);
    }

    lastScrollY = currentY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

  // Announcement bar close
  const announcementClose = document.querySelector('.announcement-bar__close');
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', function () {
      announcementBar.classList.add('is-hidden', 'is-dismissed');
    });
  }

  // ── Desktop Search Toggle ──────────────────────────────────
  const searchToggle = document.getElementById('search-toggle');
  const mobileSearchToggle = document.getElementById('mobile-search-toggle');
  const searchBar = document.getElementById('header-search');
  const searchClose = document.getElementById('search-close');
  const searchInput = searchBar ? searchBar.querySelector('.header-search__input') : null;

  function openSearch() {
    if (searchBar) {
      searchBar.classList.add('is-open');
      searchBar.setAttribute('aria-hidden', 'false');
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
    }
  }
  function closeSearch() {
    if (searchBar) {
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
    }
  }

  if (searchToggle) searchToggle.addEventListener('click', function () {
    searchBar && searchBar.classList.contains('is-open') ? closeSearch() : openSearch();
  });
  if (mobileSearchToggle) mobileSearchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // ── Mobile Menu ────────────────────────────────────────────
  const hamburgerBtn = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  const mobileClose = document.getElementById('mobile-menu-close');

  function openMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
    }
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    if (hamburgerBtn) {
      hamburgerBtn.classList.add('is-active');
      hamburgerBtn.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
    }
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    if (hamburgerBtn) {
      hamburgerBtn.classList.remove('is-active');
      hamburgerBtn.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  if (hamburgerBtn) hamburgerBtn.addEventListener('click', function () {
    mobileMenu && mobileMenu.classList.contains('is-open') ? closeMobileMenu() : openMobileMenu();
  });
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeSearch();
    }
  });

  // ── Mobile Submenu Accordions ──────────────────────────────
  document.querySelectorAll('.mobile-nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submenu = this.closest('.mobile-nav-item').querySelector('.mobile-nav-submenu');
      var isOpen = this.classList.contains('is-open');

      // Close all other submenus
      document.querySelectorAll('.mobile-nav-toggle').forEach(function (b) {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
        var sub = b.closest('.mobile-nav-item').querySelector('.mobile-nav-submenu');
        if (sub) sub.style.maxHeight = null;
      });

      // Toggle this one
      if (!isOpen && submenu) {
        this.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      }
    });
  });

  // ── Accordions (Product Page + FAQ) ────────────────────────
  document.querySelectorAll('.accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var content = this.nextElementSibling;
      var wasOpen = this.getAttribute('aria-expanded') === 'true';

      // Only auto-close siblings within product accordions group.
      // FAQ lets multiple questions stay open simultaneously.
      var group = this.closest('.product-accordions');
      if (group) {
        group.querySelectorAll('.accordion-btn').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          b.classList.remove('open');
          if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
        });
      }

      var nowOpen = !wasOpen;
      this.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      this.classList.toggle('open', nowOpen);
      if (content) content.classList.toggle('open', nowOpen);
    });
  });

  // ── Product Gallery Thumbnails ─────────────────────────────
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product-gallery__main img');
      var src = this.querySelector('img') ? this.querySelector('img').src : null;
      if (main && src) {
        main.src = src;
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  // ── Quantity Selector ──────────────────────────────────────
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    var minus = selector.querySelector('.qty-minus');
    var plus = selector.querySelector('.qty-plus');
    var input = selector.querySelector('.qty-input');

    if (minus && input) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus && input) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  // ── Variant Selection ──────────────────────────────────────
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.variant-options');
      if (group) {
        group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('selected'); });
      }
      this.classList.add('selected');
    });
  });

  document.querySelectorAll('.swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var group = this.closest('.swatch-options');
      if (group) {
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('selected'); });
      }
      this.classList.add('selected');
    });
  });

  // ── Email Popup ────────────────────────────────────────────
  var popupOverlay = document.querySelector('.email-popup-overlay');
  var popupClose = document.querySelector('.email-popup__close');
  var popupSkip = document.querySelector('.email-popup__skip');

  function closePopup() {
    if (popupOverlay) {
      popupOverlay.classList.remove('is-open');
      sessionStorage.setItem('bi_popup_dismissed', '1');
    }
  }

  if (popupOverlay && !sessionStorage.getItem('bi_popup_dismissed')) {
    setTimeout(function () { popupOverlay.classList.add('is-open'); }, 4000);
  }
  if (popupClose) popupClose.addEventListener('click', closePopup);
  if (popupSkip) popupSkip.addEventListener('click', closePopup);
  if (popupOverlay) {
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) closePopup();
    });
  }

  var popupForm = document.querySelector('.email-popup__form');
  if (popupForm) {
    popupForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = this.querySelector('input[type="email"]').value;
      if (email) {
        this.innerHTML = '<p style="text-align:center;color:var(--color-pink);font-weight:600;font-family:var(--font-heading);font-size:1.1rem;">Thank you! Your 15% off code is on its way.</p>';
        setTimeout(closePopup, 3000);
      }
    });
  }

  // ── Scroll-reveal ──────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.product-card, .collection-card, .category-tile, .why-us-card, .testimonial-card').forEach(function (el) {
      el.classList.add('fade-up');
      observer.observe(el);
    });
  }

});

/* Fade-up animation */
(function () {
  var style = document.createElement('style');
  style.textContent = [
    '.fade-up { opacity: 0; transform: translateY(24px); transition: opacity 0.5s ease, transform 0.5s ease; }',
    '.fade-up.is-visible { opacity: 1; transform: translateY(0); }'
  ].join('\n');
  document.head.appendChild(style);
})();
